import { container, TYPES } from '@/libs/di/inversify.config'
import { ref, watch } from 'vue'
import type { RoomID } from '@/types/app'
import { useDocumentVisibility } from '@vueuse/core'
import { isClientError } from '@/libs/utilities/CustomErrors'
import { captureException } from '@sentry/vue'

export const useUpdateLatestReadMessage = () => {
  const data = ref<
    Maybe<{
      roomId: RoomID
      messageGUID: string
      entranceGUID: string
    }>
  >(undefined)

  const visibility = useDocumentVisibility()

  watch([visibility, data], async ([_visibility, _data]) => {
    if (_visibility !== 'hidden' && _data) {
      try {
        await container
          .get(TYPES.MessageUsecase)
          .updateLatestReadMessage(
            _data.roomId,
            _data.entranceGUID,
            _data.messageGUID
          )
      } catch (e) {
        if (!isClientError(e)) {
          captureException(e)
          return
        }
      }

      data.value = undefined
    }
  })

  const updateLatestReadMessage = (
    roomId: RoomID,
    messageGUID: string,
    entranceGUID: string
  ) => {
    data.value = { roomId, messageGUID, entranceGUID }
  }

  return {
    updateLatestReadMessage,
  }
}
